import { useEffect } from "react";

export default function useLobbySocialBootstrap({
    actions,
    friends,
    friendsRef,
    resolvedUserSteamId,
    user,
}) {
    useEffect(() => {
        if (user) {
            actions.getMapsSelectionFromServer(user);
            if (resolvedUserSteamId) {
                // One-shot initial fetches; ongoing updates arrive via Socket.IO push.
                actions.initFriendRequests(resolvedUserSteamId);
                actions.getPendingRequests(resolvedUserSteamId);
                actions.getFriends({
                    userId: user.userId,
                    steamId: resolvedUserSteamId,
                });
            } else {
                console.warn(
                    "[LobbyPage] Skipping social init until a Steam ID is available",
                    {
                        userId: user?.userId || null,
                        steamId: user?.steamId || null,
                        steamId64: user?.steamId64 || null,
                        steam64Id: user?.steam64Id || null,
                    },
                );
            }
            actions.getLobbyByUserId(user.userId);
        }
    }, [actions, resolvedUserSteamId, user]);

    useEffect(() => {
        if (!user || !resolvedUserSteamId) return;

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                actions.getFriends({ userId: user.userId, steamId: resolvedUserSteamId });
                actions.initFriendRequests(resolvedUserSteamId);
                actions.getPendingRequests(resolvedUserSteamId);
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [actions, resolvedUserSteamId, user]);

    useEffect(() => {
        actions.clearMatchData();
        actions.fetchServerLocations();
    }, [actions]);

    useEffect(() => {
        if (user) {
            friendsRef.current = friends;
        }
    }, [friends, friendsRef, user]);
}
